import React, { useContext, useEffect, useState } from "react";
import Spinner from "./Spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import api_url from "../constants";
import { Link } from "react-router-dom";
import { ReqCallContext } from "../context/ReqCallContext";

function CreateMessage() {
  const [userContext, setUserContext] = useContext(AuthContext);
  const [reqCall, setReqCall] = useContext(ReqCallContext);
  const [cuLoading, setCuLoading] = useState(false);
  const [adminLoading, setAdminLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [adminMessageText, setAdminMessageText] = useState("");
  const [adminMessage, setAdminMessage] = useState("");
  const [playerMessage, setPlayerMesssage] = useState("");
  const [err, setError] = useState("");

  const fetchMessage = async () => {
    const response = await axios.get(`${api_url}/api/getMessage`, {
      headers: {
        Authorization: `Bearer ${userContext.token}`,
      },
    });
    setPlayerMesssage(response.data.message);
  };
  const fetchAdminMessage = async () => {
    const response = await axios.get(`${api_url}/api/getAdminMessage`, {
      headers: {
        Authorization: `Bearer ${userContext.token}`,
      },
    });
    setAdminMessage(response.data.message);
  };
  const handleSubmit = async (event, type) => {
    let endpoint = "setMessage";
    if (type === "admin") {
      endpoint = "setAdminMessage";
    }
    const msg = type === "admin" ? adminMessageText : message;
    setReqCall(reqCall + 1);
    event.preventDefault();
    try {
      setError("");
      if (type === "admin") {
        setAdminLoading(true);
      } else {
        setCuLoading(true);
      }
      const response = await axios.post(
        api_url + "/api/" + endpoint,
        {
          message: msg,
        },
        {
          headers: {
            Authorization: `Bearer ${userContext.token}`,
          },
        }
      );

      if (response.data.status) {
        fetchMessage();
        fetchAdminMessage();
        setMessage("");
        setAdminMessageText("");
        toast.success("Message updated successfully");
      } else {
        setError(response.data.msg);
      }
    } catch (error) {
      console.error(error);
      setError(
        error.response.data.msg ? error.response.data.msg : error.message
      );
    }
    setMessage("");
    setCuLoading(false);
    setAdminLoading(false);
  };
  useEffect(() => {
    fetchMessage();
    fetchAdminMessage();
  }, []);
  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="header-container">
        <h1>Create Message</h1>
        <div>
          {" "}
          <Link to={"/"} className="tag-link">
            Dashboard
          </Link>{" "}
          / Message
        </div>
      </div>
      <div className="box-container">
        <div className="box" style={{ maxWidth: "100%" }}>
          <div
            className="box-header"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <span>Create Player Message</span>
          </div>
          {err ? <div className="error-message">{err}</div> : ""}

          <form
            className="box-body"
            style={{ paddingTop: "10px" }}
            method="post"
            onSubmit={(event) => handleSubmit(event, "player")}
          >
            <div className="flex-container">
              <div className="flex-elem">Current Message:</div>
              <div> {playerMessage}</div>
            </div>
            <div className="flex-container">
              <div className="flex-elem">Message</div>
              <div className="input-cnt ">
                <textarea
                  placeholder="New Message"
                  type="password"
                  autoComplete="new-password"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
            </div>

            <div className="flex-container">
              <div className="flex-elem"></div>
              <div className="input-cnt">
                <button name="newUser" type={cuLoading ? "button" : "submit"}>
                  {cuLoading ? (
                    <Spinner color="#fff" />
                  ) : (
                    "Publish Player Message"
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="box-container">
        <div className="box" style={{ maxWidth: "100%" }}>
          <div
            className="box-header"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <span>Create Admin Message</span>
          </div>
          {err ? <div className="error-message">{err}</div> : ""}

          <form
            className="box-body"
            style={{ paddingTop: "10px" }}
            method="post"
            onSubmit={(event) => handleSubmit(event, "admin")}
          >
            <div className="flex-container">
              <div className="flex-elem">Current Message:</div>
              <div> {adminMessage}</div>
            </div>
            <div className="flex-container">
              <div className="flex-elem">Message</div>
              <div className="input-cnt ">
                <textarea
                  placeholder="New Message"
                  type="password"
                  autoComplete="new-password"
                  value={adminMessageText}
                  onChange={(e) => setAdminMessageText(e.target.value)}
                />
              </div>
            </div>

            <div className="flex-container">
              <div className="flex-elem"></div>
              <div className="input-cnt">
                <button
                  name="newUser"
                  type={adminLoading ? "button" : "submit"}
                >
                  {adminLoading ? (
                    <Spinner color="#fff" />
                  ) : (
                    "Publish Admin Message"
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateMessage;
